// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salon-care .company-info-card-heading p {
  color: #817975;
  font-size: 13px;
  margin: 5px 0 0;
}
.salon-care fieldset {
  border: 0;
  padding: 0;
  margin: 0;
  min-width: 0;
}
.salon-care .salon-care-summary {
  display: flex;
  gap: 12px;
  align-items: center;
  padding: 16px 0;
}
.salon-care .salon-care-summary strong {
  font-size: 28px;
}
.salon-care .salon-care-task {
  border: 1px solid #e9e3de;
  border-radius: 14px;
  padding: 14px;
  margin-bottom: 12px;
}
.salon-care .salon-care-task h3 {
  font-size: 16px;
  margin: 12px 0 8px;
}
.salon-care .salon-care-task p {
  font-size: 14px;
  line-height: 1.5;
}
.salon-care .salon-care-task > div, .salon-care .salon-care-task footer {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}
.salon-care .salon-care-task footer {
  font-size: 12px;
  color: #817975;
}
.salon-care .salon-care-task footer button {
  min-height: 44px;
  padding: 8px 12px;
  border-radius: 10px;
  background: #fff5ee;
  border: 0;
  color: #a8401b;
}
.salon-care .salon-care-status {
  border-radius: 8px;
  padding: 5px 8px;
  font-size: 12px;
  background: #fff0db;
  color: #8d4e00;
}
.salon-care .salon-care-status.done {
  background: #e8f6ec;
  color: #247443;
}
.salon-care .salon-care-status.publishing, .salon-care .salon-care-status.awaiting_verification, .salon-care .salon-care-status.awaiting_review {
  background: #efebff;
  color: #6547a5;
}
.salon-care .salon-care-status.blocked, .salon-care .salon-care-status.needs_revision {
  background: #ffecea;
  color: #aa302b;
}
.salon-care .salon-care-editor {
  margin-top: 16px;
}
.salon-care .salon-care-editor > summary {
  padding: 14px 0;
  cursor: pointer;
  font-weight: 600;
}
.salon-care .salon-care-editor > label, .salon-care .salon-care-editor .salon-care-attributes > label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0;
}
.salon-care .salon-care-editor textarea, .salon-care .salon-care-editor select, .salon-care .salon-care-editor input[type=time] {
  box-sizing: border-box;
  border: 1px solid #dcd6d1;
  border-radius: 10px;
  padding: 10px;
  min-height: 44px;
  width: 100%;
  font-size: 16px;
  background: #fff;
  color: #24211f;
}
.salon-care .salon-care-week > div {
  display: grid;
  grid-template-columns: 26px minmax(70px, 1fr) 12px minmax(70px, 1fr);
  align-items: center;
  gap: 6px;
  margin: 10px 0;
}
.salon-care .salon-care-week > div > label {
  grid-column: 2/-1;
  display: flex;
  gap: 8px;
  align-items: center;
  min-height: 36px;
}

.salon-care-note {
  color: #817975;
  font-size: 13px;
  line-height: 1.5;
}

.salon-care-error {
  color: #a73028;
  background: #fff1ef;
  padding: 12px;
  border-radius: 10px;
}

.salon-care-success {
  color: #267145;
  background: #edf7ef;
  padding: 12px;
  border-radius: 10px;
}

.salon-care-dialog {
  border: 0;
  border-radius: 20px;
  width: min(540px, 100% - 32px);
  max-height: 85dvh;
  padding: 22px;
  color: #272321;
  box-sizing: border-box;
  box-shadow: 0 20px 90px rgba(0, 0, 0, 0.2);
}
.salon-care-dialog::backdrop {
  background: rgba(0, 0, 0, 0.4);
}
.salon-care-dialog > header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}
.salon-care-dialog > header h2 {
  margin: 0;
  font-size: 21px;
}
.salon-care-dialog > header button {
  width: 44px;
  height: 44px;
  flex-shrink: 0;
  font-size: 25px;
  border: 0;
  background: #f5f1ee;
  border-radius: 50%;
}
.salon-care-dialog p {
  line-height: 1.5;
}
.salon-care-dialog .salon-care-comment {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.salon-care-dialog .salon-care-comment textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ddd5cf;
  border-radius: 10px;
  padding: 12px;
  font-size: 16px;
}

.salon-care-photo-picker {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
  margin: 16px 0;
}
.salon-care-photo-picker label {
  border: 1px solid #ddd5cf;
  border-radius: 12px;
  overflow: hidden;
}
.salon-care-photo-picker label img {
  width: 100%;
  height: 130px;
  object-fit: cover;
  display: block;
}
.salon-care-photo-picker label span {
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.salon-care-dialog-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin: 16px 0;
}
.salon-care-dialog-actions button {
  min-height: 44px;
  padding: 10px 14px;
  border: 1px solid #ddd5cf;
  border-radius: 10px;
  font-size: 14px;
  background: #fff;
}
.salon-care-dialog-actions button.business-primary {
  background: #ff582d;
  color: white;
  border-color: transparent;
}`, "",{"version":3,"sources":["webpack://./src/pages/CompanyInfoPage/companyPassport.scss"],"names":[],"mappings":"AACE;EAA+B,cAAA;EAAgB,eAAA;EAAiB,eAAA;AAGlE;AAFE;EAAW,SAAA;EAAW,UAAA;EAAY,SAAA;EAAW,YAAA;AAQ/C;AAPE;EAAsB,aAAA;EAAc,SAAA;EAAU,mBAAA;EAAoB,eAAA;AAapE;AAboF;EAAS,eAAA;AAgB7F;AAfE;EAAmB,yBAAA;EAA0B,mBAAA;EAAoB,aAAA;EAAc,mBAAA;AAqBjF;AArBqG;EAAK,eAAA;EAAgB,kBAAA;AAyB1H;AAzB+I;EAAI,eAAA;EAAgB,gBAAA;AA6BnK;AA7BsL;EAAc,aAAA;EAAc,8BAAA;EAA+B,SAAA;EAAU,mBAAA;EAAoB,eAAA;AAoC/Q;AApCiS;EAAS,eAAA;EAAgB,cAAA;AAwC1T;AAxCyU;EAAS,gBAAA;EAAiB,iBAAA;EAAkB,mBAAA;EAAoB,mBAAA;EAAoB,SAAA;EAAU,cAAA;AAgDva;AA/CE;EAAqB,kBAAA;EAAmB,gBAAA;EAAiB,eAAA;EAAgB,mBAAA;EAAoB,cAAA;AAsD/F;AAtD8G;EAAS,mBAAA;EAAoB,cAAA;AA0D3I;AA1D4J;EAAyD,mBAAA;EAAoB,cAAA;AA8DzO;AA9D0P;EAA6B,mBAAA;EAAoB,cAAA;AAkE3S;AAjEE;EAAqB,gBAAA;AAoEvB;AApEwC;EAAW,eAAA;EAAgB,eAAA;EAAgB,gBAAA;AAyEnF;AAzEsG;EAAsC,aAAA;EAAc,sBAAA;EAAuB,QAAA;EAAS,cAAA;AA+E1L;AA/E2M;EAAmC,sBAAA;EAAuB,yBAAA;EAA0B,mBAAA;EAAoB,aAAA;EAAc,gBAAA;EAAiB,WAAA;EAAY,eAAA;EAAgB,gBAAA;EAAiB,cAAA;AA0F/X;AAzFE;EAAuB,aAAA;EAAc,oEAAA;EAAmE,mBAAA;EAAoB,QAAA;EAAS,cAAA;AAgGvI;AAhGsJ;EAAS,iBAAA;EAAkB,aAAA;EAAc,QAAA;EAAS,mBAAA;EAAoB,gBAAA;AAuG5N;;AArGA;EAAmB,cAAA;EAAe,eAAA;EAAgB,gBAAA;AA2GlD;;AA1GA;EAAoB,cAAA;EAAe,mBAAA;EAAoB,aAAA;EAAc,mBAAA;AAiHrE;;AAhHA;EAAsB,cAAA;EAAe,mBAAA;EAAoB,aAAA;EAAc,mBAAA;AAuHvE;;AAtHA;EAAqB,SAAA;EAAU,mBAAA;EAAoB,8BAAA;EAAoC,iBAAA;EAAkB,aAAA;EAAc,cAAA;EAAe,sBAAA;EAAuB,0CAAA;AAiI7J;AAjI2L;EAAc,8BAAA;AAoIzM;AApI6N;EAAU,aAAA;EAAc,uBAAA;EAAwB,8BAAA;EAA+B,SAAA;AA0I5S;AA1IsT;EAAK,SAAA;EAAU,eAAA;AA8IrU;AA9IuV;EAAS,WAAA;EAAY,YAAA;EAAa,cAAA;EAAe,eAAA;EAAgB,SAAA;EAAU,mBAAA;EAAoB,kBAAA;AAuJtb;AAvJ6c;EAAI,gBAAA;AA0Jjd;AA1Joe;EAAsB,aAAA;EAAc,sBAAA;EAAuB,QAAA;AA+J/hB;AA/JwiB;EAAW,WAAA;EAAY,sBAAA;EAAuB,yBAAA;EAA0B,mBAAA;EAAoB,aAAA;EAAc,eAAA;AAuKlpB;;AAtKA;EAA2B,aAAA;EAAc,gDAAA;EAA+C,SAAA;EAAU,cAAA;AA6KlG;AA7KiH;EAAQ,yBAAA;EAA0B,mBAAA;EAAoB,gBAAA;AAkLvK;AAlLwL;EAAM,WAAA;EAAY,aAAA;EAAc,iBAAA;EAAkB,cAAA;AAwL1O;AAxL2P;EAAO,aAAA;EAAc,aAAA;EAAc,mBAAA;EAAoB,QAAA;AA8LlT;;AA7LA;EAA6B,aAAA;EAAc,SAAA;EAAU,eAAA;EAAgB,cAAA;AAoMrE;AApMoF;EAAS,gBAAA;EAAiB,kBAAA;EAAmB,yBAAA;EAA0B,mBAAA;EAAoB,eAAA;EAAgB,gBAAA;AA4M/L;AA5MkN;EAA0B,mBAAA;EAAoB,YAAA;EAAa,yBAAA;AAiN7Q","sourcesContent":[".salon-care {\n  .company-info-card-heading p { color: #817975; font-size: 13px; margin: 5px 0 0; }\n  fieldset { border: 0; padding: 0; margin: 0; min-width: 0; }\n  .salon-care-summary { display:flex; gap:12px; align-items:center; padding:16px 0; strong { font-size:28px; } }\n  .salon-care-task { border:1px solid #e9e3de; border-radius:14px; padding:14px; margin-bottom:12px; h3 { font-size:16px; margin:12px 0 8px; } p { font-size:14px; line-height:1.5; } >div,footer { display:flex; justify-content:space-between; gap:10px; align-items:center; flex-wrap:wrap; } footer { font-size:12px; color:#817975; button { min-height:44px; padding:8px 12px; border-radius:10px; background:#fff5ee; border:0; color:#a8401b; } } }\n  .salon-care-status { border-radius:8px; padding:5px 8px; font-size:12px; background:#fff0db; color:#8d4e00; &.done { background:#e8f6ec; color:#247443; } &.publishing,&.awaiting_verification,&.awaiting_review { background:#efebff; color:#6547a5; } &.blocked,&.needs_revision { background:#ffecea; color:#aa302b; } }\n  .salon-care-editor { margin-top:16px; >summary { padding:14px 0; cursor:pointer; font-weight:600; } >label,.salon-care-attributes>label { display:flex; flex-direction:column; gap:8px; margin:12px 0; } textarea,select,input[type=time] { box-sizing:border-box; border:1px solid #dcd6d1; border-radius:10px; padding:10px; min-height:44px; width:100%; font-size:16px; background:#fff; color:#24211f; } }\n  .salon-care-week>div { display:grid; grid-template-columns:26px minmax(70px,1fr) 12px minmax(70px,1fr); align-items:center; gap:6px; margin:10px 0; >label { grid-column:2/-1; display:flex; gap:8px; align-items:center; min-height:36px; } }\n}\n.salon-care-note { color:#817975; font-size:13px; line-height:1.5; }\n.salon-care-error { color:#a73028; background:#fff1ef; padding:12px; border-radius:10px; }\n.salon-care-success { color:#267145; background:#edf7ef; padding:12px; border-radius:10px; }\n.salon-care-dialog { border:0; border-radius:20px; width:min(540px,calc(100% - 32px)); max-height:85dvh; padding:22px; color:#272321; box-sizing:border-box; box-shadow:0 20px 90px #0003; &::backdrop { background:#0006; } >header { display:flex; align-items:flex-start; justify-content:space-between; gap:12px; h2 { margin:0; font-size:21px; } button { width:44px; height:44px; flex-shrink:0; font-size:25px; border:0; background:#f5f1ee; border-radius:50%; } } p { line-height:1.5; } .salon-care-comment { display:flex; flex-direction:column; gap:8px; textarea { width:100%; box-sizing:border-box; border:1px solid #ddd5cf; border-radius:10px; padding:12px; font-size:16px; } } }\n.salon-care-photo-picker { display:grid; grid-template-columns:repeat(2,minmax(0,1fr)); gap:12px; margin:16px 0; label { border:1px solid #ddd5cf; border-radius:12px; overflow:hidden; img { width:100%; height:130px; object-fit:cover; display:block; } span { padding:10px; display:flex; align-items:center; gap:8px; } } }\n.salon-care-dialog-actions { display:flex; gap:10px; flex-wrap:wrap; margin:16px 0; button { min-height:44px; padding:10px 14px; border:1px solid #ddd5cf; border-radius:10px; font-size:14px; background:#fff; } button.business-primary { background:#ff582d; color:white; border-color:transparent; } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
